<template>
  <div class="smy__card-full-box">
      <div class="accountRemant">
        <div class="left">
          代理等级：{{agLeven}}{{levelNum}}
        </div>
        <div class="right">
          <Button
            type="primary"
            class="search-button"
            style="margin-left:10px;"
            @click="editListModal = true, reload()"
          >升级</Button>
        </div>
      </div>
      <!-- 弹框 -->
      <Modal
        v-model="editListModal"
        width="700"
        title="升级"
        :mask-closable="false"
        :loading="loading"
        @on-ok="editList('editListForm')"
      >
      <Form
        ref="editListForm"
        label-position="right"
        :label-width="120"
        :rules="ruleValidate"
        :model="editListForm"
      >
      <FormItem label=""
      >
        <Alert type="success">对公账号：中易服信息科技有限公司 XX银行 622222222222</Alert>
      </FormItem>
        <FormItem label="升级"
          label-for="upGrade"
        >
        <RadioGroup
          v-model="leven"
          vertical>
          <Radio label="1">铜牌代理  5000.00元</Radio>
          <Radio label="2">银牌代理  10000.00元</Radio>
          <Radio label="3">金牌代理  20000.00元</Radio>
        </RadioGroup>
        </FormItem>
        <FormItem label="开户行"
          prop="bank_name"
          label-for="bank_name"
        >
          <Input
            placeholder="请输入开户行"
            element-id="bank_name"
            v-model="editListForm.bank_name"
          ></Input>
        </FormItem>
        <FormItem label="对公账户"
          prop="bank_account"
          label-for="bank_account"
        >
          <Input
            placeholder="请输入对公账户"
            element-id="bank_account"
            v-model="editListForm.bank_account"
          ></Input>
        </FormItem>
        <FormItem label="流水单号"
          prop="flow_no"
          label-for="flow_no"
        >
          <Input
            placeholder="请输入流水单号"
            element-id="flow_no"
            v-model="editListForm.flow_no"
          ></Input>
        </FormItem>
        <FormItem label=""
        >
          <span>提交后在1-2个工作日内完成充值</span>
        </FormItem>
        <FormItem label="付款凭证"
          label-for="img_urls"
        >
        <UploadImg
          :defaultList="defaultImgList"
          @on-change="editListForm.img_urls = $event">
        </UploadImg>
        </FormItem>
    </Form>
    </Modal>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg'

export default {
  components: {
    UploadImg
  },
  props: {
    accountList: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      leven: '1',
      agLeven: '',
      listLoading: false,
      editListModal: false,
      loading: true,
      defaultImgList: [],
      editListForm: {
        price: '',
        bank_name: '',
        bank_account: '',
        flow_no: '',
        img_urls: []
      },
      ruleValidate: {
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入对公账号', trigger: 'blur' }
        ],
        flow_no: [
          { required: true, message: '请输入对流水单号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    levelNum () {
      if (this.accountList.level === 0) {
        this.agLeven = '无'
      } else if (this.accountList.level === 1) {
        this.agLeven = '铜牌'
      } else if (this.accountList.level === 2) {
        this.agLeven = '银牌'
      } else if (this.accountList.level === 3) {
        this.agLeven = '金牌'
      }
    }
  },
  watch: {
    leven (val) {
    }
  },
  methods: {
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          for (let obj in this.editListForm) {
            if (obj === 'img_urls') {
              let arr = []
              this.editListForm[obj].forEach(val => {
                arr.push(val.url)
              })
              if (arr.length <= 0) {
                this.$Message.error('请上传付款凭证图')
                return
              }
              this.editListForm[obj] = arr
            }
          }
          if (this.leven === '3') {
            this.editListForm.price = '20000'
          } else if (this.leven === '2') {
            this.editListForm.price = '10000'
          } else {
            this.editListForm.price = '5000'
          }
          let data = {
            agent_level_id: this.leven,
            ...this.editListForm
          }
          let url = '/agent/account/update'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              this.$Message.success('充值成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.defaultImgList = []
      this.leven = '1'
      this.editListForm = {
        price: '',
        bank_name: '',
        bank_account: '',
        flow_no: '',
        img_urls: []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.accountRemant{
  display: flex;
  .left{
    width: 300px;
    flex-shrink: 0;
  }
  .right{
    width: 100%;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agAgencyManage/AgencyManageTop.vue